var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_454",
    "data-name": "Group 454",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.999,
    height: 12,
    viewBox: "0 0 9.999 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M10.5,2H9V.5A.472.472,0,0,0,8.5,0h-3A.472.472,0,0,0,5,.5V2H3.5A1.473,1.473,0,0,0,2,3.5v1H12v-1A1.473,1.473,0,0,0,10.5,2ZM6,1H8V2H6Z",
    transform: "translate(-1.999 0.002)",
    fill: "#00113f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M2,11v5a.5.5,0,0,0,.5.5H3V17a.472.472,0,0,0,.5.5A.472.472,0,0,0,4,17v-.5h6V17a.5.5,0,0,0,1,0v-.5h.5A.5.5,0,0,0,12,16V11Zm6,2.5H6a.5.5,0,1,1,0-1H8a.5.5,0,1,1,0,1Z",
    transform: "translate(-2 -5.5)",
    fill: "#00113f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.9b07647fc7622f1944dc02329b8f87fc.svg";
export { ForwardRef as ReactComponent };